import {DownloadPageData} from '../types';
import {default as escape} from 'escape-html';
import {InviteParameters} from './interface';

const renderAvatarWithName = ({
  inviterFirstName,
  inviterAvatarUri,
  fallbackText = 'us',
}: InviteParameters & {fallbackText: string}) =>
  inviterFirstName
    ? `${
        inviterAvatarUri ? `![avatar](${inviterAvatarUri})` : ''
      }<span class="username">${escape(inviterFirstName)}</span>`
    : fallbackText;

export const downloadPageData_Invite: DownloadPageData<InviteParameters> = {
  text: {
    en: ({inviterFirstName, inviterAvatarUri}: InviteParameters) =>
      `# Welcome to ![titleLogo](/logo.svg)\n ## Join ${renderAvatarWithName({
        inviterFirstName,
        inviterAvatarUri,
        fallbackText: 'us',
      })} and start showing off your skills on Slip 🤩!${
        inviterFirstName
          ? `  \nTap this text after installing to find ${inviterFirstName}.`
          : ''
      }`,
    nl: ({inviterFirstName, inviterAvatarUri}: InviteParameters) =>
      `# Welkom bij ![titleLogo](/logo.svg)\n ## Join ${renderAvatarWithName({
        inviterFirstName,
        inviterAvatarUri,
        fallbackText: 'ons',
      })} en kom je skills tonen op Slip 🤩!${
        inviterFirstName
          ? `  \nKlik hier na het installeren om ${inviterFirstName} te vinden.`
          : ''
      }`,
  },
  platforms: {
    iOS: {
      url: 'https://apps.apple.com/us/app/slip-app/id6449608428',
    },
    Android: {
      url: 'https://play.google.com/store/apps/details?id=com.slipbv.slipapp&utm_source=website&utm_campaign=invite-2024&pcampaignid=invite-2024-webpage',
    },
  },
};
